import TranslationKeysForm from './translation-keys-form'

export default TranslationKeysForm;